import { Box, Typography } from "@mui/material";
import { DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { isNullOrWhitespace } from "@common/stringOperations";

interface QuoteBlockProps {
    label: string;
    text: string;
}

function QuoteBlock(props: QuoteBlockProps) {
    return (
        <Box sx={{ padding: 1.5, marginBottom: 1 }}>
            <DotLegalHeader headerStyle={"small"} marginBottom={0}>
                {props.label}
            </DotLegalHeader>

            <Typography variant="body2" fontStyle="italic">
                {isNullOrWhitespace(props.text) ? undefined : props.text}
            </Typography>
        </Box>
    );
}

export default QuoteBlock;
